import React, { useState, useEffect } from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import Templates from "./Templates"
import Triggers from "./Triggers"

const MailTemplatesHome = () => {
  return (
    <SidePanelLayout
      menuName="AdminMailTemplatesMenu"
      tabs={{
        templates: Templates,
        triggers: Triggers,
      }}
    />
  )
}

export default MailTemplatesHome
